import { render } from "./AlertComponent.vue?vue&type=template&id=8a4f366a&scoped=true&ts=true&lang=pug"
import script from "./AlertComponent.vue?vue&type=script&lang=ts"
export * from "./AlertComponent.vue?vue&type=script&lang=ts"

import "./AlertComponent.vue?vue&type=style&index=0&id=8a4f366a&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/WP Darts/Admin Webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4f366a"]])

export default __exports__